module.exports = __webpack_public_path__ + "img/desktop-app-white.d0e42efa.svg";